import { MessageSchema } from "@redotech/redo-model/agents/llm-messages";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const MerchantSupportAgentThreadSchema = z.object({
  triageThreadId: zExt.objectId(),
  currentThreadId: zExt.objectId(),
  newMessages: z.array(MessageSchema),
});

export const messageMerchantSupportAgent = {
  name: "messageMerchantSupportAgent" as const,
  input: z.object({
    messages: z.array(MessageSchema),
    currentThreadId: z.string().optional(),
    triageThreadId: z
      .string()
      .optional()
      .describe("If left undefined, a new thread will be created."),
    userEmail: z
      .string()
      .optional()
      .describe("User email for context when creating a new thread."),
    pageContext: z
      .record(z.string(), z.unknown())
      .optional()
      .describe(
        "Page context object with structured data and optional message field. Example: { message: 'User is viewing return #1093', returnId: 'abc', orderId: '1093' }",
      ),
  }),
  output: z.object({ thread: MerchantSupportAgentThreadSchema }),
};

// Simplified message schema for thread history
const ThreadHistoryMessageSchema = z.object({
  id: z.string(),
  role: z.enum(["user", "assistant", "tool"]),
  content: z.union([z.string(), z.array(z.any())]),
});

export const MerchantSupportAgentThreadHistorySchema = z.object({
  _id: zExt.objectId(),
  updatedAt: z.date(),
  messages: z.array(ThreadHistoryMessageSchema),
  state: z
    .object({
      identifiers: z.object({ teamId: z.string(), userEmail: z.string() }),
      childThreads: z
        .array(
          z.object({
            agentType: z.string(),
            threadId: z.string(),
            active: z.boolean(),
          }),
        )
        .optional(),
    })
    .optional(),
});

export const getMerchantSupportAgentThreads = {
  name: "getMerchantSupportAgentThreads" as const,
  input: z.object({
    userEmail: z.string().email().describe("User email to filter threads by"),
  }),
  output: z.object({
    threads: z.array(MerchantSupportAgentThreadHistorySchema),
  }),
};

export const getMerchantSupportAgentThread = {
  name: "getMerchantSupportAgentThread" as const,
  input: z.object({ threadId: zExt.objectId() }),
  output: z.object({ thread: MerchantSupportAgentThreadHistorySchema }),
};
